var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81773 0H12.5602C13.3351 0 14.0395 0.314128 14.5506 0.82194C15.0617 1.32975 15.3779 2.02962 15.3779 2.79948V9.04297C15.3779 9.81283 15.0617 10.5127 14.5506 11.0205C14.0395 11.5283 13.3351 11.8425 12.5602 11.8425H7.68814L3.40912 15.4964C3.2109 15.6657 2.91111 15.6429 2.74073 15.4443C2.65718 15.3467 2.6195 15.2262 2.62769 15.1074L2.85541 11.8408H2.81773C2.04285 11.8408 1.33842 11.5267 0.827298 11.0189C0.316175 10.5127 0 9.81283 0 9.04297V2.79948C0 2.02962 0.316175 1.32975 0.827298 0.82194C1.33678 0.314128 2.04121 0 2.81773 0ZM12.5585 0.944011H2.81773C2.30497 0.944011 1.83808 1.15234 1.49897 1.48926C1.15986 1.82617 0.950164 2.28841 0.950164 2.79948V9.04297C0.950164 9.55241 1.15986 10.0163 1.49897 10.3532C1.83808 10.6901 2.30497 10.8984 2.81773 10.8984H3.36489V10.9001L3.39602 10.9017C3.65649 10.9196 3.85472 11.1442 3.8367 11.403L3.65158 14.0495L7.18029 11.0352C7.26548 10.9505 7.38343 10.8984 7.51449 10.8984H12.5585C13.0713 10.8984 13.5382 10.6901 13.8773 10.3532C14.2164 10.0163 14.4261 9.55241 14.4261 9.04297V2.79948C14.4261 2.29004 14.2164 1.82617 13.8773 1.48926C13.5398 1.15234 13.0729 0.944011 12.5585 0.944011Z",
    fill: "#183243"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/FolderIcon.415aad7452b30ef6006abf1dd86df267.svg";
export { ForwardRef as ReactComponent };